import React, { Component } from 'react';
import './styles.css';

export default class Billing extends Component {
  render() {
    return (
      <div className="dashboard">
        <h1>Billing Page</h1>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Billing/Billing.js